export const ASSET_ERROR_KEYS = {
  ZIP_PACKAGE: 'zip_package',
};
